import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { setDemoDevice } from '@hero/redux-data/backoffice/deviceDetails/actionCreators';

import { DetailLabel, Detail } from '../../../components/Details';
import YesNoOptions from '../../../components/YesNoOptions';
import ConfirmationModal from '../../../components/ConfirmationModal';

type Props = { id: number; demo: boolean };

const DemoDetails: React.FC<Props> = ({ id, demo }) => {
    const dispatch = useDispatch();
    const [pendingFlag, setPendingFlag] = useState<boolean | null>(null);

    const handleDemo = useCallback((flag: boolean) => {
        setPendingFlag(flag);
    }, []);

    const handleConfirm = useCallback(() => {
        if (pendingFlag !== null) {
            dispatch(setDemoDevice({ id, flag: pendingFlag }));
        }
        setPendingFlag(null);
    }, [dispatch, id, pendingFlag]);

    const handleCancel = useCallback(() => setPendingFlag(null), []);

    const isOpen = pendingFlag !== null;
    const externalControls: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = [
        isOpen,
        (val) => {
            if (!val) setPendingFlag(null);
        }
    ];

    return (
        <>
            <DetailLabel>Demo</DetailLabel>
            <Detail>
                <YesNoOptions predicate={!!demo} handleToggle={handleDemo} />
            </Detail>
            {isOpen && (
                <ConfirmationModal
                    externalControls={externalControls}
                    title="Change Demo Status"
                    description={`Are you sure you want to set the demo flag to ${pendingFlag ? 'Yes' : 'No'}?`}
                    confirmBtnLabel="Confirm"
                    cancelBtnLabel="Cancel"
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                />
            )}
        </>
    );
};

export default DemoDetails;
